$(function () {
    setTimeout(function () {
        $('#send_alert').fadeOut("slow");
    }, 40000);
});

$(function () {
    $('form').submit(function () {
        $("#send").prop('disabled', true);
    });
});

let https_url = $("#hppts_url").data("https");

var star_off_big = https_url + '/storage/img/hoshi/star-off-big.png'.trim();
var star_on_big = https_url + '/storage/img/hoshi/star-on-big.png'.trim();

$(function () {
    $('.stars').raty({
        readOnly: true,
        score: function () {
            return $(this).attr('data-scores');
        },
        starOff: star_off_big,
        starOn: star_on_big
    });
});



var star_off = https_url + '/storage/img/hoshi/star-off.png'.trim();
var star_on = https_url + '/storage/img/hoshi/star-on.png'.trim();
$(function () {
    $('.stars_sm').raty({
        readOnly: true,
        score: function () {
            return $(this).attr('data-stars-sm');
        },
        starOff: star_off,
        starOn: star_on
    });
});


$(function () {
    $(document).on('mouseover', '.hover_under_line', function (e) {
        $(this).css('border-bottom', 'solid 1px #DDDDDD');
    });

    $(document).on('mouseout', '.hover_under_line', function (e) {
        $(this).css('border-bottom', '');
    });
});
